import { DocumentNode } from 'graphql'

import { config } from './config'
import { fetchGraphQL } from './graphql-fetch'

export const wpGraphqlUri = (): string =>
  config.publicRuntimeConfig?.WP_URL || 'https://cms.beta.thirstycamel.com.au/wp/graphql'

export function fetchWpGraphQL<T extends any, V extends object>(
  query: string | DocumentNode,
  variables?: V,
) {
  return fetchGraphQL<T, V>(wpGraphqlUri(), query, variables)
}
